if ($("#formContact").length) {
  $("#formContact input.btn.btn-primary").val("Odeslat formulář");
}
